import { render, staticRenderFns } from "./applicationUsersDocuments.vue?vue&type=template&id=3596e9fc&scoped=true"
import script from "./applicationUsersDocuments.vue?vue&type=script&lang=js"
export * from "./applicationUsersDocuments.vue?vue&type=script&lang=js"
import style0 from "./applicationUsersDocuments.vue?vue&type=style&index=0&id=3596e9fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3596e9fc",
  null
  
)

export default component.exports